import styled from '@emotion/styled';

const DJLinkWrapper = styled('div')({
  position: 'absolute',
  right: '1rem',
  top: '2.5rem',
});

export default DJLinkWrapper;
